import { useEffect, useState } from 'react';
import { formatDistance } from 'date-fns';

export const useTimeSince = (timestamp: string | Date | null, formatOptions?: Parameters<typeof formatDistance>[2]) => {
  const [since, setSince] = useState(timestamp ? formatDistance(new Date(timestamp), new Date(), formatOptions) : '');

  useEffect(() => {
    if (!timestamp) return;

    const update = () => setSince(formatDistance(new Date(timestamp), new Date(), formatOptions));
    const interval = setInterval(() => update, 1000);

    update();

    return () => clearInterval(interval);
  }, [timestamp]);

  if (timestamp === null) return '';

  return since;
};
